import moment from 'moment';
import getFilenameFromContentDispositionHeader from './contentDispositionHelper';

const timeSpanRegex = /^([0-2]?[0-9]):([0-5]?[0-9])(:[0-5]?[0-9])?$/;
// This method could be used by both the application as the Excel add-on.
// As of december 2016, it is only implemented for Belgian VAT numbers.
const isValidVATNumber = (value, countryCode) => {
  if (!value) return false;
  switch (countryCode.toUpperCase()) {
    case 'BE':
      if (!/^BE [0-9]{4}[. ]?[0-9]{3}[. ]?[0-9]{3}$/.test(value)) return false;
      if (!this.isMod97Valid(value)) return false;
      return true;
    default:
      return true;
  }
};
// Does pretty much the same as the above function, but for enterprise numbers.
const isValidEnterpriseNumber = (value, countryCode) => {
  if (!value) return false;
  switch (countryCode.toUpperCase()) {
    case 'BE':
      if (!/^[0-9]{4}[. ]?[0-9]{3}[. ]?[0-9]{3}$/.test(value)) return false;
      if (!this.isMod97Valid(value)) return false;
      return true;
    default:
      return true;
  }
};
// Does a very simple check for now.
const isValidPhoneNumber = value => {
  if (!value) return false;
  if (!/^[0-9 +/()-.]{3,20}$/.test(value)) return false;
  return true;
};
// Check whether the email address is valid.
const isValidEmail = value =>
  /* eslint-disable*/
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value.toLowerCase(),
  );
// Performs a mod-97 check on the last two digits of the provided number.
const isMod97Valid = value => {
  const str = value.replace(/\D/g, ''); // Remove all non-digits.
  const number = parseInt(str.substring(0, str.length - 2), 10);
  const check = parseInt(str.substring(str.length - 2), 10);
  return 97 - (number % 97) === check;
};

const toPercentage = (value, total, roundDown = false) => {
  if (total === 0) return 0; // Wie deelt door nul is een snul

  const percentage = (value / total) * 100;
  const rounded = roundDown ? Math.floor(percentage) : percentage.toFixed(0);

  return parseFloat(rounded);
};
const getFileNameFromHeader = header => {
  if (!header) return null;
  try {
    var fileName = getFilenameFromContentDispositionHeader(header);
    if (!!fileName) return fileName;
  } catch (e) {
    //ignore
  }
  //Old method
  var result = header
    .split(';')[1]
    .trim()
    .split('=')[1];
  return result.replace(/"/g, '');
};

const arrayBufferToObject = arrayBuffer => {
  if (!arrayBuffer) return null;
  const bufferString = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
  if (bufferString) {
    const errorObject = JSON.parse(bufferString);
    return errorObject;
  }
  return {};
};

const toCamel = o => {
  let newO;
  let origKey;
  let newKey;
  let value;
  if (o instanceof Array) {
    return o.map(value => {
      if (typeof value === 'object') {
        value = toCamel(value);
      }
      return value;
    });
  }
  newO = {};
  for (origKey in o) {
    if (o.hasOwnProperty(origKey)) {
      newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
      value = o[origKey];
      if (value instanceof Array || (value !== null && value.constructor === Object)) {
        value = toCamel(value);
      }
      newO[newKey] = value;
    }
  }

  return newO;
};
const removeDuplicateSpaces = value => {
  if (!value) return value;
  return value.replace(/[ ]{2,}/g, ' ').trim();
};
const dayMonthDate = date => {
  if (!date) return date;
  const toDate = !moment.isMoment(date);

  let momentDate = moment.utc(date);
  if (!momentDate.isSame(moment.utc(date).startOf('day'))) {
    //Force conversion to utc
    momentDate = moment(date)
      .utcOffset(0)
      .utc(true);
  }
  momentDate = momentDate.set('year', 2000);

  return toDate ? momentDate.toDate() : momentDate;
};
const base64ToArrayBuffer = base64 => {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};
const splitTimeArray = totalMinutes => {
  if (Number.isNaN(totalMinutes)) return [0, 0];
  const hour = Math.floor(totalMinutes / 60);
  const minute = Math.abs(totalMinutes) % 60;
  return [hour, minute];
};
const splitTimeObj = totalMinutes => {
  if (Number.isNaN(totalMinutes)) return { hour: 0, minute: 0 };
  const hour = Math.floor(totalMinutes / 60);
  const minute = Math.abs(totalMinutes) % 60;
  return { hour, minute };
};
const joinTime = (hour, minute) => {
  const sign = hour < 0 ? -1 : 1;
  return Math.round(sign * (Math.abs(hour) || 0) * 60 + (minute || 0));
};
const decimalParser = value => {
  if (value === null) return null;
  if (typeof value === 'undefined') return null;
  if (typeof value === 'number') return value;
  let parsed;
  if (typeof value === 'string') {
    parsed = Number.parseFloat(value.replace(',', '.'));
  } else {
    parsed = Number.parseFloat(value);
  }
  if (Number.isNaN(parsed)) return value;
  return parsed;
};
//Case insensitive equals for strings
const ciEquals = (a, b) => {
  return typeof a === 'string' && typeof b === 'string'
    ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
    : a === b;
};
const timeSpanToMinutes = value => {
  if (!value) return 0;
  var match = value.match(timeSpanRegex);
  if (!match) return 0;
  const hour = parseInt(match[1], 10);
  const minute = parseInt(match[2], 10);
  return joinTime(hour, minute);
};
export const minutesToTimeSpan = (totalMinutes, withSeconds = false) => {
  var sign = totalMinutes < 0 ? '-' : '';
  var h = Math.floor(Math.abs(totalMinutes) / 60);
  var m = Math.abs(totalMinutes) % 60;
  return sign + h + ':' + (m < 10 ? '0' : '') + m + (withSeconds ? ':00' : '');
};
export const hoursToTimeSpan = totalHours => {
  var totalMinutes = Math.round(totalHours * 60);
  return minutesToTimeSpan(totalMinutes);
};

const roundAmount = (initialAmount, roundingMethod, roundingDecimals) => {
  const digits = Math.max(Math.min(roundingDecimals, 5), 0); //Should be a number between 0 and 5
  const factor = Math.pow(10, digits);
  switch (roundingMethod) {
    case 0: //Normal
      return Math.round(initialAmount * factor) / factor;
    case 1: //Round up
      return Math.ceil(initialAmount * factor) / factor;
    case 2: //Round down
      return Math.floor(initialAmount * factor) / factor;
  }
  return initialAmount;
};

const roundAwayFromZero = value => {
  // toFixed(2) does not round correctly in some case
  // example:
  // base amount = 1.5
  // discount of 5%, so we multiple base with 0.95
  // in js this results in a taxable amount of 1.4249999999999998 because all numbers are floats)
  // but we want 1.43 as result (same as c# backend calculations)
  // https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

const roundToHalfDecimal = value => {
  if (value === null || typeof value === 'undefined') return value;
  return (Math.sign(value) * Math.ceil(Math.abs(value) * 2)) / 2;
};
const roundToSteps = (value, steps = 0.5) => {
  const factor = 1 / steps;
  if (value === null || typeof value === 'undefined') return value;
  return (Math.sign(value) * Math.ceil(Math.abs(value) * factor)) / factor;
};

const calculateIndexedAmount = (
  initialAmount,
  method,
  amountOrPercentage,
  roundingMethod,
  roundingDecimals,
) => {
  switch (method) {
    case 0: {
      //Percentage
      const percentage = amountOrPercentage / 100;
      const percentageAmount = initialAmount * percentage;
      return roundAmount(initialAmount + percentageAmount, roundingMethod, roundingDecimals);
    }
    case 1: {
      //AddFixedAmount
      return initialAmount + amountOrPercentage;
    }
    case 2: {
      //NewAmount (replace)
      return amountOrPercentage;
    }
    default: {
      console.warn('Unknown updateAmountMethod: ' + method);
      return initialAmount;
    }
  }
};
const randomAmount = () => {
  return Math.round(Math.random() * 100000) / 100;
};

const toDateOnly = value => {
  if (!value) return null;
  if (typeof value === 'string') return moment.utc(value.substr(0, 10)).toDate();
  if (value instanceof Date) return moment.utc(value.ISO()).toDate();
  return moment
    .utc(
      moment
        .utc(value)
        .toDate()
        .ISO(),
    )
    .toDate();
};
const toMomentDateOnly = value => {
  if (!value) return null;
  if (typeof value === 'string') return moment.utc(value.substr(0, 10));
  if (value instanceof Date) return moment.utc(value.ISO());
  return moment.utc(
    moment
      .utc(value)
      .toDate()
      .ISO(),
  );
};

export const parseIntOrNull = value => {
  if (value === null) return null;
  if (typeof value === 'undefined') return null;
  var intValue = parseInt(value);
  if (Number.isNaN(intValue)) return null;
  return intValue;
};

const ogmRegex = /\+*([0-9]{3})\/?([0-9]{4})\/?([0-9]{5})\+*/g;
export const formatOGM = value => {
  if (!value || typeof value !== 'string') return value;
  return value.replace(ogmRegex, '+++$1/$2/$3+++');
};

const adminpulse = {
  isValidVATNumber,
  isValidEnterpriseNumber,
  isValidPhoneNumber,
  isValidEmail,
  isMod97Valid,
  toPercentage,
  getFileNameFromHeader,
  arrayBufferToObject,
  toCamel,
  removeDuplicateSpaces,
  dayMonthDate,
  base64ToArrayBuffer,
  splitTimeArray,
  splitTimeObj,
  joinTime,
  decimalParser,
  ciEquals,
  timeSpanToMinutes,
  minutesToTimeSpan,
  hoursToTimeSpan,
  calculateIndexedAmount,
  roundAmount,
  randomAmount,
  toDateOnly,
  toMomentDateOnly,
  parseIntOrNull,
  roundAwayFromZero,
  roundToHalfDecimal,
  roundToSteps,
};

export default adminpulse;
